import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { whatsapp: () => import('./WhatsAppPage.vue') },
} satisfies FeatureRoutes
